<template>
  <div class="app-container" :class="!is_bind?'app-page':''">
    <van-nav-bar :title="$t('setting.bank_info')" class="app-nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="app-wrapper">
      <div class="bank-settings-page__add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" color="#5a98d0" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>
      <div class="bank-settings-page__bank" v-else>
          <div class="app-info">
            <div class="bank-settings-page__row-content">{{this.bankInfo.bankinfo}}</div>
            <div class="bank-settings-page__row-content">{{this.userInfo.name}}</div>
            <div class="bank-settings-page__row-content">{{this.bankInfo.bankid}}</div>
          </div>
      </div>
      <div class="app-tips">{{$t("setting.bind_bank_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      // if (!this.userInfo.name) {
      //   this.$router.push("/account/profile/name");
      //   this.$toast(this.$t("setting.set_name_bank"));
      //   return true;
      // } else
      if (!this.userInfo.paypassword) {
        this.$router.push("/account/security/payment-password/create");
        this.$toast(this.$t("setting.set_pwd_bank"));
        return true;
      } else {
        this.$router.push({path:'/account/payment-methods/bind'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/auth/login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped src="./Setbank.styles.less"></style>
